var Command = /** @class */ (function () {
    function Command() {
        this.then = this.then.bind(this);
        this.catch = this.catch.bind(this);
    }
    Command.prototype.then = function (response) {
        console.log(response);
    };
    Command.prototype.catch = function (error) {
        console.error(error);
    };
    return Command;
}());
export default Command;
